import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import axios from "axios";

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
    key: "EProTracker",
    storage: window.localStorage,
    reducer: (state) => ({
        formAuthenticated: state.formAuthenticated,
        formGuid: state.formGuid,
        linkStatus: state.linkStatus,
        dataEntryPIN: state.dataEntryPIN,
        menuItems: state.menuItems,
        onboardingFormData: state.onboardingFormData,
        mainMenuDrawer: state.mainMenuDrawer,
        currentRoutePath: state.currentRoutePath,
        defaultPage: state.defaultPage,
    }),
});

export default new Vuex.Store({
    state: {
        crfTitle: "",
        menuItems: [],
        onboardingFormData: {
            tbFrmEligibilityForm: {},
        },
        defaultPage: "first",

        customErrors: [],
        formAuthenticated: "",
        formGuid: "",
        linkStatus: "",
        showAppBusyAnimation: false,
        mainMenuDrawer: null,
        currentRoutePath: "",
        dataEntryPIN: null,
        globalFields: {},
        formHasUnsavedChanges: false,
        stepNotSavedMsg: false,
    },
    mutations: {
        setOnboardingFormData(state, { dataTableID, newData }) {
            state.onboardingFormData[dataTableID] = newData;
        },
        clearOnboardingFormData(state) {
            //untested
            state.onboardingFormData = {};
        },
        setCrfTitle(state, title) {
            state.crfTitle = title;
        },
        setFormAuthenticated(state, formId) {
            state.formAuthenticated = formId;
        },
        setFormGuid(state, guid) {
            state.formGuid = guid;
        },
        setLinkStatus(state, status) {
            state.linkStatus = status;
        },
        setAppBusyAnimation(state, status) {
            state.showAppBusyAnimation = status;
        },
        setFormHasUnsavedChanges(state, status) {
            state.formHasUnsavedChanges = status;
        },
        setStepNotSavedMsg(state, status) {
            state.stepNotSavedMsg = status;
        },
        setMainMenuDrawer(state, status) {
            state.mainMenuDrawer = status;
        },
        setCurrentRoutePath(state, routePath) {
            state.currentRoutePath = routePath;
        },
        setFormCompleteness(state, value) {
            //debugger;
            let mItem = state.menuItems.find((m) => m.to == state.currentRoutePath);
            if (mItem) {
                mItem.formCompleteness = value;
            }
        },
        setMenuItems(state, menuItems) {
            state.menuItems = menuItems;
        },
        showMenuItems(state, { menuItemIds, status }) {
            //debugger;
            let mItem;
            menuItemIds.forEach((id) => {
                mItem = state.menuItems.find((m) => m.id == id);
                if (mItem) {
                    mItem.showMenuItem = status;
                }
            });
        },
        setDataEntryPin(state, pin) {
            state.dataEntryPIN = pin;
        },
        clearDataEntryPin(state) {
            state.dataEntryPIN = null;
        },
        clearFormAuthenticated(state) {
            state.formAuthenticated = "";
        },
        clearFormGuid(state) {
            state.formGuid = "";
        },
        appendErrorItem(state, errorItem) {
            //debugger;
            if (
                !state.customErrors.some(
                    (p) => p.id == errorItem.id && p.msg == errorItem.msg
                )
            ) {
                state.customErrors.push(errorItem);
            }
        },
        removeErrorItem(state, errorItem) {
            //debugger;
            for (let i = state.customErrors.length - 1; i >= 0; i -= 1) {
                if (state.customErrors[i].id == errorItem.id) {
                    state.customErrors.splice(i, 1);
                }
            }
        },
        clearErrors(state) {
            //debugger;
            state.customErrors = [];
        },
        resetDataEntry(state) {
            //debugger;
            state.dataEntryPIN = null;
            state.menuItems = [];
            state.formAuthenticated = "";
            state.formGuid = "";
            state.currentRoutePath = "";
            state.defaultPage = "first";
        },
        clearFormLinkCache(state) {
            //debugger;      
            state.menuItems = [];
            state.formAuthenticated = "";
            state.formGuid = "";
            state.currentRoutePath = "";
            state.defaultPage = "first";
        },
        removeMenuItem(state, id) {
            state.menuItems.forEach((item, index) => {
                if (item.to == id) {
                    state.menuItems.splice(index, 1);
                }
            });
        },
        clearMenuItems(state) {
            state.menuItems = [];
        },
        clearCurrentRoutePath(state) {
            state.currentRoutePath = "";
        },
        setDefaultPage(state, page) {
            state.defaultPage = page;
        },
    },
    getters: {
        getOnboardingFormData(state) {
            return state.onboardingFormData;
        },
        customValidationIsClean(state) {
            //debugger;
            if (state.customErrors.length == 0) {
                return true;
            } else {
                return false;
            }
        },
        getCurrentRoutePath(state) {
            return state.currentRoutePath;
        },
        getFormAuthenticated(state) {
            //debugger;
            return state.formAuthenticated;
        },
        getFormGuid(state) {
            //debugger;
            return state.formGuid;
        },
        getLinkStatus(state) {
            //debugger;
            return state.linkStatus;
        },
        getAppBusyAnimation(state) {
            //debugger;
            return state.showAppBusyAnimation;
        },
        getFormHasUnsavedChanges(state) {
            //debugger;
            return state.formHasUnsavedChanges;
        },
        getStepNotSavedMsg(state) {
            //debugger;
            return state.stepNotSavedMsg;
        },
        getMainMenuDrawer(state) {
            //debugger;
            return state.mainMenuDrawer;
        },
        getDataEntryPin(state) {
            return state.dataEntryPIN;
        },
        getCrfTitle(state) {
            //debugger;
            return state.crfTitle;
        },
        getMenuItems(state) {
            //debugger;
            return state.menuItems;
        },
        getMenuItemFormCompleteness: (state) => (id) => {
            const { formCompleteness, caption } = state.menuItems.find(
                (p) => p.id === id
            );
            return formCompleteness
                ? {
                    formCompleteness: parseInt(
                        formCompleteness.substr(0, formCompleteness.length - 1)
                    ),
                    caption,
                }
                : { formCompleteness: 0, caption: "" };
        },
        getNextIncompleteCrfUrl(state) {
            //debugger;
            let nextMenuItem = state.menuItems.find(
                (p) => p.formCompleteness != "100%" && p.showMenuItem == true
            );
            if (nextMenuItem) {
                return nextMenuItem.to;
            } else if (state.menuItems.length > 0) return state.menuItems[0].to;
            else return "/";
        },
        getNextCrfUrl(state) {
            let cIndex = state.menuItems.indexOf(
                state.menuItems.find((m) => m.to == state.currentRoutePath)
            );
            if (
                cIndex < state.menuItems.length - 1 &&
                state.menuItems[cIndex + 1].showMenuItem == true
            ) {
                return state.menuItems[cIndex + 1].to;
            } else {
                return "/";
            }
        },
        getPrevCrfUrl(state) {
            let cIndex = state.menuItems.indexOf(
                state.menuItems.find((m) => m.to == state.currentRoutePath)
            );
            if (cIndex > 0) {
                return state.menuItems[cIndex - 1].to;
            } else {
                return "/";
            }
        },
        getAppGlobalFields(state) {
            //debugger;
            return state.globalFields;
        },
        getDefaultPage(state) {
            return state.defaultPage;
        },
    },
    actions: {
        async getLinkStatus(context, guid) {
            //debugger;
            try {
                context.commit("setAppBusyAnimation", true);
                let actionUrl = "api/Notification/GetLinkStatus";
                let rData = await axios.get(actionUrl, { params: { guid: guid } });
                context.commit("setLinkStatus", rData.data);
                context.commit("setAppBusyAnimation", false);
            } catch (error) {
                context.commit("setLinkStatus", -1);
            }
        },
        async getPinStatus(context, { pin, guid }) {
            try {
                context.commit("setAppBusyAnimation", true);
                let actionUrl = "api/Notification/ValidateFormSubmissionPIN";
                const response = await axios.get(actionUrl, { params: { pin, guid } });
                return response.data;
            } catch (error) {
                return -1;
            } finally {
                context.commit("setAppBusyAnimation", false);
            }
        },
        async getFormCompleteness(context) {
            //debugger;
            try {
                context.commit("setAppBusyAnimation", true);
                let actionUrl = "api/Notification/GetFormCompleteness";
                let rData = await axios.get(actionUrl, {
                    params: { guid: context.state.formGuid },
                });
                rData = rData.data;

                if (rData.formCompleteness.length > 0) {
                    rData.formCompleteness.forEach((item) => {
                        let mItem = context.state.menuItems.find(
                            (p) => p.id === item.tableName
                        );
                        if (mItem) mItem.formCompleteness = `${item.formCompleteness}%`;
                    });
                }
                context.commit("setAppBusyAnimation", false);
            } catch (error) {
                let m = error;
                context.commit("setAppBusyAnimation", false);
                return m;
            }
        },
        async getGlobalFields(context) {
            //debugger;
            if (!context.state.formGuid) return;
            try {
                context.commit("setAppBusyAnimation", true);
                let actionUrl = "api/DynamicCrf/GetGlobalFields";
                let rData;
                ({ data: rData } = await axios.get(actionUrl, {
                    params: { guid: context.state.formGuid },
                }));
                Object.assign(context.state.globalFields, rData);
                context.commit("setAppBusyAnimation", false);
            } catch (error) {
                let m = error;

                context.commit("setAppBusyAnimation", false);
                return m;
            }
        },
    },
    plugins: [vuexLocalStorage.plugin],
});
